import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISelectedHierarchy } from 'src/types/SelectedHierarchy';

const initialState: ISelectedHierarchy = {
  hierarchySponsor: '',
  hierarchyStudy: '',
  hierarchyCountry: '',
  hierarchySite: '',
  isPageDetailsLoaded: false
};

export const selectedHierarchy = createSlice({
  name: 'selectedHierarchy',
  initialState,
  reducers: {
    setSelectedHierarchy: (state, action: PayloadAction<any>) => {
      state.hierarchySponsor = action.payload.hierarchySponsor;
      state.hierarchyStudy = action.payload.hierarchyStudy;
      state.hierarchyCountry = action.payload.hierarchyCountry;
      state.hierarchySite = action.payload.hierarchySite;
    },
    clearSelectedHierarchy: state => {
      state.hierarchySponsor = '';
      state.hierarchyStudy = '';
      state.hierarchyCountry = '';
      state.hierarchySite = '';
    },
    setHierarchyPageDetailsLoaded: (state, action: PayloadAction<any>) => {
      state.isPageDetailsLoaded = action.payload;
    }
  }
});

export const { setSelectedHierarchy, clearSelectedHierarchy, setHierarchyPageDetailsLoaded } =
  selectedHierarchy.actions;
